function RevealerController(){
	this.className	= "RevealerController";
	this.glob		= "/**";
	this.debug		= false;
	this.staffTypesSet = false;
};
RevealerController.inheritsFrom( StandardController );
RevealerController.prototype.setupPage = function(){
	console.log("RevealerController: setupPage called");
};
RevealerController.prototype.swap = function(){
	this.$body				= $("body").find(".js-body");
	this.$page 				= this.$body.find(".js-page");
};
RevealerController.prototype.on = function(){
  var revealerHeaderElement = $('.revealer-header');
  revealerHeaderElement.click(function() {
    var revealer = $(this).parent();
		revealer.toggleClass('open');
		
		// The staff types need to be configured only after opening the container for the first time
		// to guarantee it will bet the initial dimensions of each tag.
		// It doesn't work while the revealer is still closed.
		if (!this.staffTypesSet) {
			var staffTypesController = new StaffTypesController();
			staffTypesController.configStaffTypes(revealer);
			this.staffTypesSet = true;
		}
  })
};
RevealerController.prototype.off = function(){
};